<template>
  <div>
    <ul>
        <li v-for="(item, index) in response" v-bind:key="index">
          <h4 class="title">{{questions[index].title}}<br/>
            <small>Producent: <strong>{{questions[index].company}}</strong>, Numer części: <strong>{{questions[index].partsKey}}</strong></small>
          </h4>
          <p>
            Twoja cena zakupu <strong>{{item.value}}</strong>zł jest:
          </p>
          <SummaryRow
          v-bind:range="getRangeResult(questions[index], item.value)"
          v-bind:rangesText="questions[index].rangesText"
          @incrementPoints="incrementPoints"
          />
        </li>
      </ul>
    <div class="header-summary">
      <div class="summary-content">
        <span class="mark">!</span>
        <h5 class="summary-title"><span>Wniosek?</span></h5>
        <div v-if="status == 1">
          <h4>Masz bardzo niskie ceny na zakup części.</h4>
          <p class="lead">Wygląda na to, że Twój dystrybutor sprzedaje Ci części z niską marzą.</p>
        </div>
        <div v-else-if="status == 2">
          <h3>Wynegocjowałeś rozsądne warunki.</h3>
          <p class="lead">Wiele wskazuje na to, że kupujesz części w rozsądnych cenach. Warsztaty podobnej wielkości do Twojego otrzymują podobne rabaty w swoich hurtowniach.</p>
        </div>
        <div v-else-if="status == 3">
          <h3>Masz wysokie ceny na zakup części.</h3>
          <p class="lead">Wygląda na to, że Twój hurtownik bardzo dobrze na Tobie zarabia. Chyba musisz porozmawiać ze swoim handlowcem o lepszych rabatach.</p>
        </div>
        <div class="info">
          Jest to wersja beta porównywarki, co oznacza, że stale ją udoskonalamy.
          Chcesz się z nami podzielić opinią? Napisz nam maila <a href="mailto:mailto:redakcja@motofocus.pl">redakcja@motofocus.pl</a>, lub zostaw komentarz pod <a href="https://motofocus.pl/specjalne/60861/porownaj-swoje-ceny-czesci-z-innymi" target="_blank">artykułem</a>.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import SummaryRow from './SummaryRow'
export default {
  name: 'Summary',
  props: {
    apiUrl: {
      type: String
    },
    questions: {
      type: Array
    },
    response: {
      type: Array
    }
  },
  data: function () {
    return {
      points: 0,
      counter: 0,
      status: 0
    }
  },
  created: function () {
    // window.scrollTo(0, 0)
    // let self = this
    // axios.post(this.apiUrl + '?action=getPriceAVG', this.response)
    //   .then(function (response) {
    //     self.avg = response.data
    //     self.questions.forEach(function (element, index) {
    //       if (self.avg[element.id]) {
    //         self.questions[index].average_price = self.avg[element.id]
    //       }
    //     }, this)
    //   })
    //   .catch(function (error) {
    //     console.log(error)
    //   })
    // this.avg = null
  },
  mounted: function () {
    setTimeout(function () {
      document.documentElement.scrollTop = 0
    }, 20)
  },
  methods: {
    getRangeResult: function (question, value) {
      for (let i = 0; i < question.ranges.length; i++) {
        let range = question.ranges[i]
        if (value >= range[0] && value <= range[1]) {
          return i
        }
      }
      return null
    },
    getRangeProcentResult: function (question, value) {
      if (question.average_price === 0) {
        return null
      }
      let procent = (value / question.average_price) * 100
      for (let i = 0; i < question.ranges.length; i++) {
        let range = question.ranges[i]
        if (procent > range[0] && procent <= range[1]) {
          return i
        }
      }
      return null
    },
    incrementPoints: function (value) {
      this.points = this.points + value
      this.counter++
      if (this.counter === this.response.length) {
        this.showDescription()
      }
    },
    showDescription: function () {
      if (this.points <= 8) {
        this.status = 1
      } else if (this.points >= 9 && this.points <= 11) {
        this.status = 2
      } else if (this.points >= 12) {
        this.status = 3
      }
    }
  },
  components: {
    SummaryRow
  }
}
</script>

<style lang="scss" scoped>
$primary: #0069d9;
ul{
  padding:0px;
  list-style: none;
  li{
    padding: 0px;
    margin-bottom: 30px;
    small{
      opacity: 0.4;
      font-size: 12px;
    }
    p{
      padding:5px 0px;
      margin-bottom:5px;
    }
  }
}
.header-summary{
  img{
    margin-bottom: 15px;
    margin-top: 15px;
  }
  .info{
    margin-top: 15px;
    font-size: 12px;
    background-color: lighten(#F2F2F2,3%);
    margin:15px -15px -15px -15px;
    color:darken(#F2F2F2,30%);
    padding:15px;
  }
}
.title{
  margin-bottom:0px;
}
.summary-title{
  margin-bottom: 10px;
}
.summary-content{
  position: relative;
  margin-left: 70px;
  .mark{
    position: absolute;
    top:0px;
    left: -70px;
    width:50px;
    height: 50px;
    line-height: 33px;
    text-align: center;
    background-color: $primary;
    color: white;
    font-size: 30px;
    border-radius: 25px;
  }
  background-color: #F2F2F2;
  padding:15px;
  p{
    margin:0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Summary.vue